export default __webpack_public_path__ + "static/media/liel-eli.3b85c1ec.png";